//https://medium.com/front-end-hacking/persisting-user-authentication-with-vuex-in-vue-b1514d5d3278

import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { bus } from '../main'
import router from '@/router'

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    items: [],
    programme: {
      name: null,
      collection: {
        knowledge: [],
        products: []
      },
      closed: false
    },
    isLoggedIn: !!localStorage.getItem("token"),
    accountData: null,
    params: {
      crossdomain: true,
      withCredentials: true,
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("token"),
      }
    },
    collectionPanelIsVisible: true
  },
  getters: {
    knowledgeInCollection: (state) => (itemId, knowledgeId) => {
      return state.programme.collection.knowledge.findIndex(
        e => parseInt(e.itemId) === parseInt(itemId)
        && parseInt(e.knowledgeId) === parseInt(knowledgeId))
    },
    productInCollection: (state) => (itemId, productId) => {
      return state.programme.collection.products.findIndex(
        e => parseInt(e.itemId) === parseInt(itemId)
        && parseInt(e.productId) === parseInt(productId))
    },
    isLoggedIn: (state) => {
      return state.isLoggedIn
    },
    isAdmin: (state) => {
      if (state.accountData)
        if (state.accountData.level_id === 1)
          return true

      return false
    },
    isSupplier: (state) => {
      if (state.accountData)
        if (state.accountData.level_id === 2)
          return true

      return false
    },
    accountData: (state) => {
      return state.accountData
    },
    params: (state) => {
      return state.params
    },
    programme: (state) => {
      return state.programme
    },
    getCollectionPanelVisibility: (state) => {
      return state.collectionPanelIsVisible
    }
  },
  mutations: {
    setItems (state, items) {
      state.items = items;
    },
    setKnowledgeInCollection (state, data) {
      state.programme.collection.knowledge.unshift(data)
    },
    removeKnowledgeFromCollection (state, e) {
      state.programme.collection.knowledge.splice(e, 1)
    },
    setProductInCollection (state, data) {
      state.programme.collection.products.unshift(data)
    },
    removeProductFromCollection (state, e) {
      state.programme.collection.products.splice(e, 1)
    },
    toggleCollection (state) {
      state.collectionPanelIsVisible = !state.collectionPanelIsVisible
    },
    authUser (state, userData) {
      localStorage.setItem("token", userData.token)
      state.isLoggedIn = true
    },
    destroyAuth (state) {
      localStorage.removeItem("token")
      if (localStorage.getItem("token") === null)
        state.accountData = {}
        state.isLoggedIn = false
        router.push({ name: 'home' })
    },
    setAccountData (state, accountData) {
      state.accountData = accountData

      if (accountData.level_id === 1)
        state.isAdmin = true
    },
    addProgramm (state, programme) {
      state.programme = programme
      state.accountData.programmes.push(programme)
    },
    setProgramme(state, programme) {
      state.programme = programme
      state.programme.closed = false
    },
    REMOVE_PROGRAMME (state, id) {
      state.accountData.programmes.splice(state.accountData.programmes[state.accountData.programmes.findIndex(x => x.id === id)], 1)
    },
    READ_NOTIFICATION (state, params) {
        let notification = state.accountData.notifications.find((notification) => {
            return notification.id === params.id
        })

        notification.read_at = params.read_at
    },
    ARCHIVE_NOTIFICATION (state, params) {
        let notification = state.accountData.notifications.find((notification) => {
            return notification.id === params.id
        })

        notification.archived_at = params.archived_at
    }
  },
  actions: {
    fetchItems ({ commit }, { self }) {
      axios.get("data/items", { crossdomain: true })
      .then((response) => {
        commit("setItems", response.data)
      })
      .catch((error) => {
        console.log(error);
      })
    },
    signIn ({ commit }, authData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/auth/login', authData)
          .then(response => {
            commit('authUser', {
              token: response.data.access_token
            })
            resolve()
          })
          .catch(error => {
            bus.$emit('invalidLogin')
          })
      })
    },
    signOut ({ commit }) {
      axios
        .get('/auth/logout', {
          crossdomain: true,
          withCredentials: true,
          headers: {
            "Authorization": "Bearer " + localStorage.getItem("token"),
          }
        })
        .then(response => {
          if (response.status === 200)
            commit('destroyAuth')
        })
        .catch(error => {
          console.log(error)
        })
    },
    getAccountData ({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/user', {
            crossdomain: true,
            withCredentials: true,
            headers: {
              "Authorization": "Bearer " + localStorage.getItem("token"),
            }
          })
          .then(response => {
            if (response.status === 200)
              commit('setAccountData', response.data)

            resolve()
          })
          .catch(error => {
            console.log(error)
          })
      })
    },
    updateAccountData ({ commit }, accountData) {
      commit('setAccountData', accountData)
    },
    addProductToCollection ({ commit }, payload) {
      axios
        .get(`/data/product/${payload.productId}/item/${payload.itemId}`)
        .then(response => {
          commit('setProductInCollection', {
            itemId: payload.itemId,
            productId: payload.productId,
            product: response.data
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    addKnowledgeToCollection ({ commit }, payload) {
      axios
        .get(`/data/knowledge/${payload.knowledgeId}/item/${payload.itemId}`)
        .then(response => {
          commit('setKnowledgeInCollection', {
            itemId: payload.itemId,
            knowledgeId: payload.knowledgeId,
            knowledge: response.data
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    fetchProgramme ({ commit }, id) {
      axios.get(
        `programmes/${id}`
      ).then(
        (res) => {
          commit('setProgramme', res.data)
        }
      ).catch(
        (err) => {
          console.error(err)
        }
      )
    },
    downloadProgramme({ commit }, programme) {
      axios({
        url: `programmes/download/${programme.id}`,
        method: 'get',
        headers: {'Accept': 'application/pdf'},
        responseType: 'blob'
      }).then(
        (res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');

          link.href = url;
          link.setAttribute('download', `${programme.name}.pdf`);

          document.body.appendChild(link);

          link.click();
        }
      )
    },
    removeProgramme ({ commit }, id) {
      axios.delete(
        `programmes/${id}`
      ).then(
        (res) => {
          commit('REMOVE_PROGRAMME', id)
        }
      ).catch(
        (err) => {
          console.error(err)
        }
      )
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js